import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS, JR_ACO_GROUP, SR_ACO_GROUP, DES_PROVEEDORES_GROUP, PROVIDER_GROUP, CODI_GROUP, SUPERVISOR_GROUP, FACTURACION_GROUP, COBRANZA_GROUP, AUX_CM_GROUP } from './utils'

export default [
  {
    path: '/',
    name: 'Proveedores',
    component: Layout,
    meta: {
      showInSidebar: true,
      icon: 'mdi-account-network',
      excludeGroup: [...EXTRANET_GROUPS, JR_ACO_GROUP, SR_ACO_GROUP, FACTURACION_GROUP, COBRANZA_GROUP],
      ifCan: {
        view: 'providers/provider'
      }
    },
    children: [
      {
        path: '/proveedores/listado',
        name: 'Provider List',
        component: () => import('@/pages/Providers/Listing'),
        meta: {
          title: 'Listado',
          showInSidebar: true,
          forceRefresh: true,
          excludeGroup: ['Proveedor']
        }
      },
      {
        path: '/proveedores/nuevo',
        name: 'Provider Create',
        component: () => import('@/pages/Providers/Register/'),
        meta: {
          showInSidebar: true,
          title: 'Registrar proveedor',
          excludeGroup: [DES_PROVEEDORES_GROUP, CODI_GROUP, SUPERVISOR_GROUP, AUX_CM_GROUP],
          ifCan: {
            add: 'providers/provider'
          }

        }
      },
      {
        path: '/proveedores/cuentas',
        name: 'Provider Accounts',
        component: () => import('@/pages/Providers/Accounts'),
        meta: {
          title: 'Cuentas',
          showInSidebar: true,
          forceRefresh: true,
          ifCan: {
            view: 'providers/advancesinvoice'
          }
        }
      },
      {
        path: '/proveedores/cuentas_totales',
        name: 'Total Provider Accounts',
        component: () => import('@/pages/Providers/TotalAccounts'),
        meta: {
          title: 'Cuentas totales',
          showInSidebar: true,
          forceRefresh: true,
          ifCan: {
            view: 'providers/advancesinvoice'
          },
          excludeGroup: [PROVIDER_GROUP]
        }
      },
      {
        path: '/proveedores/siniestros_cerrados_proveedores_a_prueba',
        name: 'Closed Sinister By On Trial Providers',
        component: () => import('@/pages/Providers/ClosedSinisterByOnTrialProviders'),
        meta: {
          title: 'Seguimiento de proveedores',
          showInSidebar: true,
          forceRefresh: true,
          ifCan: {
            'closed_sinisters_report': 'providers/provider'
          },
          excludeGroup: ['Proveedor']
        }
      },
      {
        path: '/proveedores/dashboard_proveedores',
        name: 'Dashboard providers',
        component: () => import('@/pages/Providers/DashboardProviders'),
        meta: {
          title: 'Dashboard proveedores',
          showInSidebar: true,
          forceRefresh: true,
          ifCan: {
            'closed_sinisters_report': 'providers/provider'
          },
          excludeGroup: ['Proveedor']
        }
      },
      // {
      //   path: '/proveedores/bitacora_actividad_proveedores',
      //   name: 'Providers Activity Log',
      //   component: () => import('@/pages/Providers/ProviderActivityLog'),
      //   meta: {
      //     title: 'Bitácora Actividad Proveedores',
      //     showInSidebar: true,
      //     forceRefresh: true,
      //     ifCan: {
      //       'closed_sinisters_report': 'providers/provider'
      //     },
      //     excludeGroup: ['Proveedor']
      //   }
      // },
      {
        path: '/proveedores/editar/:providerSlug',
        name: 'Provider Edit',
        props: true,
        component: () => import('@/pages/Providers/Register/'),
        meta: {
          showInSidebar: false,
          title: 'Editar proveedor',
          excludeGroup: [DES_PROVEEDORES_GROUP],
          ifCan: {
            change: 'providers/provider'
          }
        }
      },
      {
        path: '/proveedores/:providerSlug',
        name: 'Provider File',
        props: true,
        component: () => import('@/pages/Providers/File/'),
        meta: {
          showInSidebar: false,
          title: 'Ficha de proveedor',
          excludeGroup: ['Proveedor']
        }
      }
    ]
  }
]
